<template>
    <div class="form-input-container">
        <div class="form-title"><label>{{translate(label)}} <span class="required" v-if="required">*</span></label></div>
        <div style="display: flex; align-items: center;">
            <v-select label="name" inputId="id" :clearable="false" :options="list" v-model="localValue"></v-select>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            value: {}, label: {}, list: {},
            required: {
                type: Boolean,
                default: true
            },
            type: {
                type: String,
                default: "text"
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                localValue: null
            }
        },
        created() {
            this.setFieldValue();
        },
        methods: {
            setFieldValue() {
                let set = false;
                for(let i =0; i < this.list.length; i++) {
                    if(this.list[i].id == this.value) {
                        set = true;
                        this.localValue = this.list[i];
                    }
                }
                if(!set) this.localValue = "";
            },
        },
        watch: {
            localValue(val) {
                this.$emit('input', val.id != undefined ? val.id : "");
            },
            value(val) {
                this.setFieldValue();
            },
            list(val) {
                // console.log(this.list);
            }
        },
        computed: {
            model: {
                get() {
                    return this.localValue
                },
                set(value) {
                    if (value.constructor.name.toLowerCase() !== 'inputevent') {
                        this.$nextTick(() => {
                            this.localValue = value
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .form-input-container {
        margin-bottom: 12px;
    }

    .form-title {
        margin-bottom: 8px;
    }

    .v-select {
        width: 100%;
        border: 2px solid #EEE;
        border-radius: 6px;
        height: 38px;
    }

    .v-select:focus {
        border: 2px solid #353690;
    }
</style>


// WEBPACK FOOTER //
// src/components/Forms/Select.vue